import { createContext, useContext } from "react";
import { getColors } from "./constants";

export const ColorsContext = createContext(getColors(false));
export const useColors = () => useContext(ColorsContext);
